export type WellKnownLearningMaterialCategory = {
  id: string;
  path: string;
};

export class WellKnownLearningMaterialCategories {
  static readonly podcasts: WellKnownLearningMaterialCategory = { id: "131646459", path: "podcasts" };
  static readonly audioAndVideo: WellKnownLearningMaterialCategory = { id: "170998707", path: "audio-and-video" };
  static readonly articles: WellKnownLearningMaterialCategory = { id: "170998708", path: "articles" };
  static readonly newsletters: WellKnownLearningMaterialCategory = { id: "197429286", path: "newsletters" };
}

export class WellKnownLearningMaterialSubCategories {
  static readonly fitness: string = "174918121";
  static readonly recipes: string = "174918120";
  static readonly sleep: string = "131645122";
  static readonly meditation: string = "LLIj6ohFTxChgK9dqf4RDA";
  static readonly students: string = "131646500";
  static readonly anxious: string = "Fuj65mvoSDmLj-FTc7yqiA";
}
